// Molecules
import VmClientDisclosure from './molecules/vm-client-disclosure/vm-client-disclosure';
import VmVideoCommentsListItem from './molecules/vm-video-comments-list-item/vm-video-comments-list-item';
import VmVideoCommentsList from './molecules/vm-video-comments-list/vm-video-comments-list';

// Organisms
import VmVideoComments from './organisms/vm-video-comments/vm-video-comments';

import VmChatbotLoader from './vm-chatbot-loader/vm-chatbot-loader';
import VmChatbotSkeleton from './vm-chatbot-skeleton/vm-chatbot-skeleton';

import VmListPagination from './vm-list-pagination/vm-list-pagination';
import VmLoadingSpinner from './vm-loading-spinner/vm-loading-spinner';
export { VmProfileImage } from './atoms/vm-profile-image/vm-profile-image';
import VmSortDropdown from './vm-sort-dropdown/vm-sort-dropdown';

// Molecules
customElements.define('vm-video-comments-list', VmVideoCommentsList);
customElements.define('vm-video-comments-list-item', VmVideoCommentsListItem);
customElements.define('vm-client-disclosure', VmClientDisclosure);

// Organisms
customElements.define('vm-video-comments', VmVideoComments);

customElements.define('vm-chatbot-loader', VmChatbotLoader);
customElements.define('vm-chatbot-skeleton', VmChatbotSkeleton);

customElements.define('vm-list-pagination', VmListPagination);
customElements.define('vm-sort-dropdown', VmSortDropdown);
customElements.define('vm-loading-spinner', VmLoadingSpinner);
